import { render } from "./SendEmailModal.vue?vue&type=template&id=56f3f1ae"
import script from "./SendEmailModal.vue?vue&type=script&lang=js"
export * from "./SendEmailModal.vue?vue&type=script&lang=js"

import "@/assets/scss/domains/app/components/common/_send-email-modal.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__